import { DOCUMENT } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { AbstractTuiThemeSwitcher } from '@taiga-ui/cdk';

// @dynamic
@Component({
  selector: 'app-theme-night',
  template: '',
  styleUrls: ['./theme-night.style.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppThemeNightComponent extends AbstractTuiThemeSwitcher {
  constructor(@Inject(DOCUMENT) documentRef: Document) {
    super(documentRef);
  }
}
